const hogesProctoringEvents = require('./proctoring');
const hogesTestStatusEvents = require('./testStatus');
const hogesFraudEvents = require('./fraud');
const hogesProgressEvents = require('./progress');

/**
 * TEST EVENTS FOR HOGESCHOOLTAL
 */
module.exports = {
  hogesProctoringEvents,
  hogesTestStatusEvents,
  hogesFraudEvents,
  hogesProgressEvents,
};
